var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _vm.resData
        ? _c(
            "div",
            {
              staticClass: "row",
              attrs: {
                gutter: 20,
                type: "flex",
                align: "middle",
                justify: "start"
              }
            },
            _vm._l(_vm.computedOrigin, function(item) {
              return _c(
                "div",
                {
                  key: item.stock_storehouse_id,
                  staticClass: "status",
                  class: { active: _vm.origin_id == item.stock_storehouse_id },
                  on: {
                    click: function($event) {
                      return _vm.selectOrigin(item.stock_storehouse_id)
                    }
                  }
                },
                [_vm._v("\n      " + _vm._s(item.storehouse_name) + "\n    ")]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "按件数添加", name: "5" } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-form",
                    {
                      ref: "form",
                      staticClass: "demo-form-inline",
                      attrs: { inline: true, model: _vm.form }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "波次件数" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100px" },
                            attrs: { placeholder: "最少件数" },
                            model: {
                              value: _vm.form.wave_min,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "wave_min", $$v)
                              },
                              expression: "form.wave_min"
                            }
                          }),
                          _vm._v("-\n            "),
                          _c("el-input", {
                            staticStyle: { width: "100px" },
                            attrs: { placeholder: "最大件数" },
                            model: {
                              value: _vm.form.wave_max,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "wave_max", $$v)
                              },
                              expression: "form.wave_max"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "发送快递" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "发送快递" },
                              model: {
                                value: _vm.form.shipping_company,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "shipping_company", $$v)
                                },
                                expression: "form.shipping_company"
                              }
                            },
                            _vm._l(_vm.resData.shipping, function(shipping) {
                              return _c("el-option", {
                                key: shipping.cpid,
                                attrs: {
                                  label: shipping.shipping_company,
                                  value: shipping.cpid
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.onSubmit }
                            },
                            [_vm._v("添加")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { float: "right" },
                          attrs: { label: "其他" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "发送快递" },
                              on: { change: _vm.saveDefault },
                              model: {
                                value: _vm.form.default_shipping,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "default_shipping", $$v)
                                },
                                expression: "form.default_shipping"
                              }
                            },
                            _vm._l(_vm.resData.shipping, function(shipping) {
                              return _c("el-option", {
                                key: shipping.cpid,
                                attrs: {
                                  label: shipping.shipping_company,
                                  value: shipping.cpid
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              !_vm.loading
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { staticStyle: { border: "1px solid #ddd" } },
                        [
                          _vm.resData.list
                            ? _c(
                                "div",
                                { staticStyle: { "margin-bottom": "0" } },
                                [
                                  _c(
                                    "el-table",
                                    {
                                      directives: [
                                        {
                                          name: "loading",
                                          rawName: "v-loading",
                                          value: _vm.tableLoading,
                                          expression: "tableLoading"
                                        }
                                      ],
                                      ref: "multipleTable",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        height: "600",
                                        data: _vm.resData.list,
                                        "tooltip-effect": "dark",
                                        "row-class-name": _vm.tableRowClassName
                                      }
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "wave_num",
                                          label: "波次件数",
                                          "show-overflow-tooltip": "",
                                          align: "center"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "shipping_company",
                                          label: "发送快递",
                                          "show-overflow-tooltip": "",
                                          align: "center"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "admin_name",
                                          label: "更新人",
                                          "show-overflow-tooltip": "",
                                          align: "center"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "create_time",
                                          label: "更新时间",
                                          "show-overflow-tooltip": "",
                                          align: "center"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          fixed: "right",
                                          label: "操作",
                                          "show-overflow-tooltip": "",
                                          align: "center"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(scope) {
                                                return [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "text",
                                                        size: "small"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.handleDel(
                                                            scope.row,
                                                            5
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("删除")]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1196442087
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "按地区添加", name: "10" } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-form",
                    {
                      ref: "form",
                      staticClass: "demo-form-inline",
                      attrs: { inline: true, model: _vm.form }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "province" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "150px" },
                              attrs: { multiple: "", placeholder: "省" },
                              on: { change: _vm.getCity },
                              model: {
                                value: _vm.form.province,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "province", $$v)
                                },
                                expression: "form.province"
                              }
                            },
                            _vm._l(_vm.resData.province, function(item) {
                              return _c("el-option", {
                                key: item.region_id,
                                attrs: {
                                  label: item.region_name,
                                  value: item.region_id
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "city" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "150px" },
                              attrs: { multiple: "", placeholder: "市" },
                              on: { change: _vm.getDistrict },
                              model: {
                                value: _vm.form.city,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "city", $$v)
                                },
                                expression: "form.city"
                              }
                            },
                            _vm._l(_vm.cityData.list, function(item) {
                              return _c("el-option", {
                                key: item.region_id,
                                attrs: {
                                  label: item.region_name,
                                  value: item.region_id
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "district" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "150px" },
                              attrs: { multiple: "", placeholder: "区/县" },
                              model: {
                                value: _vm.form.district,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "district", $$v)
                                },
                                expression: "form.district"
                              }
                            },
                            _vm._l(_vm.districtData.list, function(item) {
                              return _c("el-option", {
                                key: item.region_id,
                                attrs: {
                                  label: item.region_name,
                                  value: item.region_id
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "shipping_company" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "发送快递" },
                              model: {
                                value: _vm.form.shipping_company,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "shipping_company", $$v)
                                },
                                expression: "form.shipping_company"
                              }
                            },
                            _vm._l(_vm.resData.shipping, function(shipping) {
                              return _c("el-option", {
                                key: shipping.cpid,
                                attrs: {
                                  label: shipping.shipping_company,
                                  value: shipping.cpid
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.fetchData }
                            },
                            [_vm._v("查询")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.resetForm("form")
                                }
                              }
                            },
                            [_vm._v("\n              重置")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.showImportShippingRuleMesaage }
                            },
                            [_vm._v("\n              地区快递设置导入")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-upload",
                            {
                              ref: "upload",
                              staticStyle: { margin: "0 10px 2px" },
                              attrs: {
                                action: _vm.action,
                                name: "excel",
                                data: { origin_id: _vm.origin_id },
                                limit: 1,
                                "on-success": _vm.importFile,
                                "file-list": _vm.fileList,
                                "auto-upload": false,
                                "with-credentials": ""
                              }
                            },
                            [
                              _c("el-button", {
                                ref: "uploadButton",
                                staticStyle: { display: "none" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.outputMb }
                            },
                            [_vm._v("\n              导出系统省市区")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.outputData }
                            },
                            [_vm._v("导出")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              !_vm.loading
                ? _c(
                    "el-row",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            background: "#f3f3f3",
                            height: "50px",
                            padding: "0 25px",
                            display: "flex",
                            "align-items": "center"
                          }
                        },
                        [
                          _c("div", [_vm._v("数据列表：")]),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: { "margin-left": "auto" },
                              attrs: { type: "primary", size: "mini" },
                              on: {
                                click: function($event) {
                                  _vm.dialogFormVisible = true
                                }
                              }
                            },
                            [_vm._v("\n            添加")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { type: "danger", size: "mini" },
                              on: {
                                click: function($event) {
                                  return _vm.batchDelete(10)
                                }
                              }
                            },
                            [_vm._v("\n            批量删除")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        { staticStyle: { border: "1px solid #ddd" } },
                        [
                          _vm.resData.list
                            ? _c(
                                "div",
                                { staticStyle: { "margin-bottom": "0" } },
                                [
                                  _c(
                                    "el-table",
                                    {
                                      directives: [
                                        {
                                          name: "loading",
                                          rawName: "v-loading",
                                          value: _vm.tableLoading,
                                          expression: "tableLoading"
                                        }
                                      ],
                                      ref: "multipleTable",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        height: "600",
                                        data: _vm.resData.list,
                                        "tooltip-effect": "dark",
                                        "row-class-name": _vm.tableRowClassName
                                      },
                                      on: {
                                        "selection-change":
                                          _vm.handleSelectionChange
                                      }
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          type: "selection",
                                          width: "55"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "province",
                                          label: "省",
                                          "show-overflow-tooltip": "",
                                          align: "center"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "city",
                                          label: "市",
                                          align: "center"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(scope) {
                                                return [
                                                  _c(
                                                    "el-popover",
                                                    {
                                                      attrs: {
                                                        trigger: "hover",
                                                        placement: "top"
                                                      }
                                                    },
                                                    [
                                                      _c("p", [
                                                        _vm._v(
                                                          _vm._s(scope.row.city)
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "name-wrapper",
                                                          attrs: {
                                                            slot: "reference"
                                                          },
                                                          slot: "reference"
                                                        },
                                                        [
                                                          _c(
                                                            "el-tag",
                                                            {
                                                              attrs: {
                                                                size: "medium"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  scope.row.city
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          4068484484
                                        )
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "district",
                                          label: "区县",
                                          "show-overflow-tooltip": "",
                                          align: "center"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "wave_num",
                                          label: "波次件数",
                                          "show-overflow-tooltip": "",
                                          align: "center"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "shipping_company",
                                          label: "发送快递",
                                          "show-overflow-tooltip": "",
                                          align: "center"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "admin_name",
                                          label: "更新人",
                                          "show-overflow-tooltip": "",
                                          align: "center"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "update_time",
                                          label: "更新时间",
                                          "show-overflow-tooltip": "",
                                          align: "center"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          fixed: "right",
                                          label: "操作",
                                          "show-overflow-tooltip": "",
                                          align: "center"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(scope) {
                                                return [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "text",
                                                        size: "small"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.handleDel(
                                                            scope.row,
                                                            10
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("删除")]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          3177782579
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.areaData_10.total
                            ? _c("el-pagination", {
                                staticStyle: { "text-align": "right" },
                                attrs: {
                                  background: "",
                                  layout: "prev, pager, next, jumper",
                                  total: _vm.areaData_10.total,
                                  "page-size": _vm.areaData_10.psize,
                                  "current-page": _vm.areaData_10.page
                                },
                                on: { "current-change": _vm.cahngePage }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "按用户添加", name: "15" } },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-form",
                    {
                      ref: "form15",
                      staticClass: "demo-form-inline",
                      attrs: { inline: true, model: _vm.form15 }
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "用户id" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "400px" },
                            attrs: {
                              placeholder: "用户id,多个用户id请用英文逗号隔开"
                            },
                            model: {
                              value: _vm.form15.user_ids,
                              callback: function($$v) {
                                _vm.$set(_vm.form15, "user_ids", $$v)
                              },
                              expression: "form15.user_ids"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "发送快递" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "发送快递" },
                              model: {
                                value: _vm.form15.shipping_company,
                                callback: function($$v) {
                                  _vm.$set(_vm.form15, "shipping_company", $$v)
                                },
                                expression: "form15.shipping_company"
                              }
                            },
                            _vm._l(_vm.resData.shipping, function(shipping) {
                              return _c("el-option", {
                                key: shipping.cpid,
                                attrs: {
                                  label: shipping.shipping_company,
                                  value: shipping.cpid
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.onSubmit15 }
                            },
                            [_vm._v("添加")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              !_vm.loading
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { staticStyle: { border: "1px solid #ddd" } },
                        [
                          _vm.resData.list
                            ? _c(
                                "div",
                                { staticStyle: { "margin-bottom": "0" } },
                                [
                                  _c(
                                    "el-table",
                                    {
                                      directives: [
                                        {
                                          name: "loading",
                                          rawName: "v-loading",
                                          value: _vm.tableLoading,
                                          expression: "tableLoading"
                                        }
                                      ],
                                      ref: "multipleTable",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        height: "600",
                                        data: _vm.resData.list,
                                        "tooltip-effect": "dark",
                                        "row-class-name": _vm.tableRowClassName
                                      }
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "user_ids",
                                          label: "用户id",
                                          "show-overflow-tooltip": "",
                                          align: "center"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "shipping_company",
                                          label: "发送快递",
                                          "show-overflow-tooltip": "",
                                          align: "center"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "admin_name",
                                          label: "更新人",
                                          "show-overflow-tooltip": "",
                                          align: "center"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          prop: "create_time",
                                          label: "更新时间",
                                          "show-overflow-tooltip": "",
                                          align: "center"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("el-table-column", {
                                        attrs: {
                                          fixed: "right",
                                          label: "操作",
                                          "show-overflow-tooltip": "",
                                          align: "center"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function(scope) {
                                                return [
                                                  _c(
                                                    "el-button",
                                                    {
                                                      attrs: {
                                                        type: "text",
                                                        size: "small"
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.handleDel(
                                                            scope.row,
                                                            15
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [_vm._v("删除")]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          884203670
                                        )
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "快递费率表", name: "16" } },
            [
              _c("ExpressRateSchedule", {
                attrs: { "origin-id": _vm.origin_id }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "快递时效表", name: "17" } },
            [
              _c("ShippingAgingList", { attrs: { "origin-id": _vm.origin_id } })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "物流联通表", name: "18" } },
            [
              _c("ShippingConnectList", {
                attrs: { "origin-id": _vm.origin_id }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "物流合作表", name: "19" } },
            [
              _c("ShippingCooperate", { attrs: { "origin-id": _vm.origin_id } })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加",
            visible: _vm.dialogFormVisible,
            width: "30%"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { ref: "form10", attrs: { model: _vm.form10 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "省",
                    "label-width": "120px",
                    prop: "province"
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "省" },
                      on: { change: _vm.getCity },
                      model: {
                        value: _vm.form10.province,
                        callback: function($$v) {
                          _vm.$set(_vm.form10, "province", $$v)
                        },
                        expression: "form10.province"
                      }
                    },
                    _vm._l(_vm.resData.province, function(item) {
                      return _c("el-option", {
                        key: item.region_id,
                        attrs: {
                          label: item.region_name,
                          value: item.region_id
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: "城市", "label-width": "120px", prop: "city" }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "市" },
                      on: { change: _vm.getDistrict },
                      model: {
                        value: _vm.form10.city,
                        callback: function($$v) {
                          _vm.$set(_vm.form10, "city", $$v)
                        },
                        expression: "form10.city"
                      }
                    },
                    _vm._l(_vm.cityData.list, function(item) {
                      return _c("el-option", {
                        key: item.region_id,
                        attrs: {
                          label: item.region_name,
                          value: item.region_id
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "区/县",
                    "label-width": "120px",
                    prop: "district"
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "区/县" },
                      model: {
                        value: _vm.form10.district,
                        callback: function($$v) {
                          _vm.$set(_vm.form10, "district", $$v)
                        },
                        expression: "form10.district"
                      }
                    },
                    _vm._l(_vm.districtData.list, function(item) {
                      return _c("el-option", {
                        key: item.region_id,
                        attrs: {
                          label: item.region_name,
                          value: item.region_id
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "起始波次件数",
                    "label-width": "120px",
                    prop: "wave_min"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "起始波次件数" },
                    model: {
                      value: _vm.form10.wave_min,
                      callback: function($$v) {
                        _vm.$set(_vm.form10, "wave_min", $$v)
                      },
                      expression: "form10.wave_min"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "终止波次件数",
                    "label-width": "120px",
                    prop: "wave_max"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: "终止波次件数" },
                    model: {
                      value: _vm.form10.wave_max,
                      callback: function($$v) {
                        _vm.$set(_vm.form10, "wave_max", $$v)
                      },
                      expression: "form10.wave_max"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "发送快递",
                    "label-width": "120px",
                    prop: "shipping_company"
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "发送快递" },
                      model: {
                        value: _vm.form10.shipping_company,
                        callback: function($$v) {
                          _vm.$set(_vm.form10, "shipping_company", $$v)
                        },
                        expression: "form10.shipping_company"
                      }
                    },
                    _vm._l(_vm.resData.shipping, function(shipping) {
                      return _c("el-option", {
                        key: shipping.cpid,
                        attrs: {
                          label: shipping.shipping_company,
                          value: shipping.cpid
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.dialogFormVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.onSubmit10 } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04cb75d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04cb75d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wavepicking/ShippingRule/ShippingRule.vue
// module id = null
// module chunks = 